import { useGet } from '../../../sharedModules/hooks/useQuery';
import { Statement } from '../model';

export const STATEMENTS_URL = '/collections/statements';

export const statementsQueryKey = (location: string) => [STATEMENTS_URL, { location }] as const;

export function useStatements(location: string, enabled = true) {
  return useGet<Statement[]>({
    url: STATEMENTS_URL,
    params: { location },
    enabled,
  });
}
